export const MAX_NUMBER_OF_ZONES = 250;